import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './react/store';
import { BrowserRouter } from 'react-router-dom';
import LayoutSelector from './react/layout/LayoutSelector';
import { NotificationProvider } from './react/providers/NotificationProvider';
import { AppTheme } from './react/navigation';
import { ConfigProvider } from 'antd';
import './sass/rm-sass.scss';
import './react/styles/styles.scss';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
      <ConfigProvider theme={AppTheme} >
        <Provider store={store}>
            <NotificationProvider>
              <LayoutSelector />
            </NotificationProvider>
        </Provider>
      </ConfigProvider>
  </BrowserRouter>
);